/**
 * Escape HTML entities to prevent XSS attacks in templates.
 * User-provided data (insuredName, claimNumber, etc.) must be escaped
 * before rendering in HTML templates.
 *
 * @param unsafe - The potentially unsafe string to escape
 * @returns The escaped string safe for HTML rendering
 */
export function escapeHtml(unsafe: string | undefined | null): string {
  if (!unsafe) return '';
  return String(unsafe)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');
}

/**
 * Reverse escapeHtml — restore the original string from HTML-escaped text.
 * Order matters: &amp; must be last to avoid double-unescaping.
 */
export function unescapeHtml(str: string): string {
  return str
    .replace(/&#039;/g, "'")
    .replace(/&quot;/g, '"')
    .replace(/&gt;/g, '>')
    .replace(/&lt;/g, '<')
    .replace(/&amp;/g, '&');
}
